import { TitleCasePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'spaces',
  standalone: false,
})
export class SpacesPipe implements PipeTransform {
  constructor(readonly titleCasePipe: TitleCasePipe) {}

  transform(value: string): string {
    if (value) {
      return this.titleCasePipe.transform(
        value.toString().replace(/_/g, ' ') || value
      );
    } else {
      return '';
    }
  }
}
